export default "__VITE_ASSET__C_XmLsl1__"